<template>
	<div>
		<Header :sel='type' @changePhone="changePhone" />
		<div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
			
			<!-- * 内页banner * -->
			<div class="page-banner">
				<img src="@/assets/images/banner06.png" >
				<div class="nybt">
					<h3>项目案例</h3>
				</div>
			</div>
			
			<!-- * 当前位置 * -->
			<div class="page-position">
				<div class="wh">
					当前位置：
					<a href="/">首页</a>
					&gt;
					项目案例 {{title?('>'+title):''}}
				</div>
			</div>
			
			<!-- * 主体部分 * -->
			<div class="page-wrap">
				<div class="wh clearfix">
					<!-- * 左侧 * -->
					<div class="page-wrap-left xymob-menu-click visible-xs visible-sm">
						<div class="xymob-left-close-btn"><i class="icon-font icon-close"></i></div>
						<div class="xypg-left">
							<!-- * 分类 * -->
							
			
						
			
							
							
						</div>
					</div>
			
					<!-- * 右侧 * -->
					<div class="page-wrap-right">
			
						<div class="xypg-right-content">
						
								<!-- 产品列表页 -->
								<ul class="xypg-product-list clearfix">
									<li v-for="item in list" @click="goDetail(item.id)">
										<a href="javascript:void(0)" class="img"><img
												:src="item.image" /></a>
										<h3><a href="javascript:void(0)">{{item.title}}</a></h3>
									</li>
								</ul>
								<div class="xypg-pagination">
									<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
										:current-page="pageNum" :page-sizes="[12, 24, 48, 96]"
										:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
										:total="total">
									</el-pagination>
								</div>
							</div>
						</div>
					</div>
			
					<!-- * 手机弹窗 * -->
			
				</div>
			</div>
			
			<Footer></Footer>

		</div>


	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import {
		articleList,
		articleDetail
	} from '@/api/reqFetch.js'
	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header
		},
		data() {
			return {
				tabList: [],
				selName: '',
				selid: '0',
				list: [],
				pageNum: 1,
				indexs: [],
				showPhone: false,
				type: '',
				categoryCode: '',
				configList: [],
				selOneName: '',
				title: '',
				total: 0,
				pageSize:12,
				
			}
		},

		mounted() {
			this.type = this.$route.query.type
			this.title = this.$route.query.title
			this.getData()

		},

		methods: {
			
			goDetail(id) {
				this.$router.push({
					path: 'caseDetail?id='+id,
				})
			},

			
			// 页码容量变化
			handleSizeChange(pageSize) {
				this.pageNum = 1
				this.pageSize = pageSize
				this.getData()
			},
			
			// 当前页码变化
			handleCurrentChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			changePhone(val) {
				this.showPhone = val
			},
			
			
			getData() {
				let par = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					status: 1,
					categoryCode: this.type
				}
				articleList(par).then(res => {
					this.list = res.rows;
					this.total = res.total
					
				});
			},
			
		}
	}
</script>

<style scoped>
	.logo-img {
		width: 180px;
		height: 55px;
		flex-shrink: 0
	}
</style>